<script setup lang="ts">
import { KsButton } from "@aschehoug/kloss";

definePageMeta({
  middleware: ["check-auth"],
});

const route = useRoute();

const login = useLogin(() => route.query.redirectTo?.toString());

useHead({
  bodyAttrs: {
    class: "bg-beige-10",
  },
});
</script>

<template>
  <div class="flex flex-col">
    <LayoutBreadCrumbs
      :text-conversions="{ login: 'Logg inn' }"
      :background="true"
    />
    <Content
      is="main"
      id="main-content"
      class="my-10 flex grow gap-40 text-green-50  md:my-20"
    >
      <section class="flex flex-col gap-6 sm:gap-8">
        <h1 class="font-headline text-4xl font-normal sm:text-6xl">
          Logg inn
        </h1>
        <p class="text-lg md:text-xl lg:text-2xl">
          Ved å logge inn kan du kjøpe læremidler og få oversikt over tidligere
          kjøp. Du kan også se hvilke læremidler du har tilgang til.
        </p>
        <section class="flex flex-col items-start gap-3 sm:gap-5">
          <KsButton
            class="!text-lg"
            variant="primary"
            shape="rounded"
            @click="login('feide')"
          >
            Logg inn med Feide
          </KsButton>
          <vipps-mobilepay-button
            type="button"
            brand="vipps"
            language="no"
            variant="primary"
            :rounded="true"
            verb="login"
            :stretched="false"
            :branded="true"
            :loading="false"
            @click="login('vipps')"
          />
        </section>
      </section>
      <StaticAsset
        folder="images"
        file="characters-login.png"
        class="hidden h-fit basis-1/3 object-contain sm:block"
      />
    </Content>
  </div>
</template>
